import PropTypes from 'prop-types'

export const styledSystemResponsivePropTypes = (type) =>
  PropTypes.oneOfType([
    type,
    PropTypes.shape({
      MOBILE: type,
      TABLET: type,
      DESKTOP: type,
      TV: type,
    }),
  ])
